import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { CasesItem } from '@/api';
import { PaginationState, SortingState } from '@tanstack/react-table';

interface CasesState {
  casesList: CasesItem[];
  casesRowCount: number;
  casesPagination: PaginationState;
  casesSorting: SortingState;
  casesFinding: string;
}

const initialState: CasesState = {
  casesList: [],
  casesRowCount: 0,
  casesPagination: {
    pageIndex: 0,
    pageSize: 50
  },
  casesSorting: [{ id: 'dueDate', desc: false }],
  casesFinding: ''
};

const casesSlice = createSlice({
  name: 'cases',
  initialState: initialState,
  reducers: {
    setCasesList: (state, action: PayloadAction<CasesItem[]>) => {
      state.casesList = action.payload;
    },
    setCasesRowCount: (state, action: PayloadAction<number>) => {
      state.casesRowCount = action.payload;
    },
    setCasesPagination: (state, action: PayloadAction<PaginationState>) => {
      state.casesPagination = action.payload;
    },
    setCasesSorting: (state, action: PayloadAction<SortingState>) => {
      state.casesSorting = action.payload;
    },
    setCasesFinding: (state, action: PayloadAction<string>) => {
      state.casesFinding = action.payload;
    }
  }
});

export const { setCasesList, setCasesRowCount, setCasesPagination, setCasesSorting, setCasesFinding } =
  casesSlice.actions;

export const selectCasesList = (state: RootState) => {
  return state.cases.casesList;
};
export const selectCasesRowCount = (state: RootState) => {
  return state.cases.casesRowCount;
};
export const selectCasesPagination = (state: RootState) => {
  return state.cases.casesPagination;
};
export const selectCasesSorting = (state: RootState) => {
  return state.cases.casesSorting;
};
export const selectCasesFinding = (state: RootState) => {
  return state.cases.casesFinding;
};

export const casesReducer = casesSlice.reducer;
